import { createSlice } from "@reduxjs/toolkit";
import {
  getPartsPaged,
  getPart,
  addPart,
  updatePart,
  addPartImages,
  publish
} from "./thunk";

export const initialState = {
  pagedParts: [],
  paginationInfo: {},
  partDetails: "",
  suggestedPrices: [],
  error: {},
  pageRequest: { page: 1, size: 25, statusFilter: 1, searchInput: null, searchField: null }
};
const PartSlice = createSlice({
  name: "PartSlice",
  initialState,
  reducer: {},
  extraReducers: (builder) => {    
    builder.addCase(publish.fulfilled, (state, action) => {
      if(action.payload != "There was a problem!"){
        state.pagedParts = state.pagedParts.map(part =>
          part.id === action.payload.id ? { ...part, ...action.payload } : part
        );
        state.partDetails = action.payload;
        sessionStorage.setItem("partDetails", JSON.stringify(state.partDetails));
        sessionStorage.setItem("pagedParts", JSON.stringify(state.pagedParts));
      }
    });

    builder.addCase(getPartsPaged.fulfilled, (state, action) => {
      state.pagedParts = action.payload.response;
      state.paginationInfo = {
        currentPage: action.payload.page,
        currentPageSize: action.payload.size,
        totalRows: action.payload.totalRows,
        totalPages: action.payload.totalPages
      };
      state.pageRequest = { 
        page: action.payload.page, 
        size: action.payload.size, 
        statusFilter: action.payload.statusFilter, 
        searchInput: action.payload.searchInput, 
        searchField: action.payload.searchField 
      };

      if(!(state.suggestedPrices && state.suggestedPrices.length)) state.suggestedPrices = action.payload.commonPrices;
      sessionStorage.setItem("pagedParts", JSON.stringify(state.pagedParts));
      sessionStorage.setItem("paginationInfo", JSON.stringify(state.paginationInfo));
      sessionStorage.setItem("pageRequest", JSON.stringify(state.pageRequest));
      sessionStorage.setItem("suggestedPrices", JSON.stringify(state.suggestedPrices));
    });

    builder.addCase(getPart.fulfilled, (state, action) => {
      state.partDetails = action.payload;
      sessionStorage.setItem("partDetails", JSON.stringify(state.partDetails));
    });

    builder.addCase(addPart.fulfilled, (state, action) => {
      state.pagedParts.unshift(action.payload);
      const prices = state.suggestedPrices.find(item => item === action.payload.sellingPrice);
      if(!prices) state.suggestedPrices = [action.payload.sellingPrice, state.suggestedPrices[0], state.suggestedPrices[1]];

      sessionStorage.setItem("pagedParts", JSON.stringify(state.pagedParts));
      sessionStorage.setItem("suggestedPrices", JSON.stringify(state.suggestedPrices));
    });

    builder.addCase(updatePart.fulfilled, (state, action) => {
      state.pagedParts = state.pagedParts.map(part =>
        part.id === action.payload.id ? { ...part, ...action.payload } : part
      );
      const prices = state.suggestedPrices.find(item => item === action.payload.sellingPrice);
      if(!prices) state.suggestedPrices = [action.payload.sellingPrice, state.suggestedPrices[0], state.suggestedPrices[1]];
      state.partDetails = action.payload;
      
      sessionStorage.setItem("partDetails", JSON.stringify(state.partDetails));
      sessionStorage.setItem("pagedParts", JSON.stringify(state.pagedParts));
      sessionStorage.setItem("suggestedPrices", JSON.stringify(state.suggestedPrices));
    });

    builder.addCase(addPartImages.fulfilled, (state, action) => {
      state.pagedParts = state.pagedParts.map(part =>
        part.id === action.payload.id ? { ...part, ...action.payload } : part
      );
      state.partDetails = action.payload;
      sessionStorage.setItem("partDetails", JSON.stringify(state.partDetails));
      sessionStorage.setItem("pagedParts", JSON.stringify(state.parts));
    });

    builder.addCase(getPartsPaged.rejected, (state, action) => { state.error = action.payload || null; });
    builder.addCase(getPart.rejected, (state, action) => { state.error = action.payload || null; });
    builder.addCase(addPart.rejected, (state, action) => { state.error = action.payload || null; });
    builder.addCase(updatePart.rejected, (state, action) => { state.error = action.payload || null; });
    builder.addCase(addPartImages.rejected, (state, action) => { state.error = action.payload || null; });
  },
});

export default PartSlice.reducer;